import {DataFetcher, useGrpcRequest} from '@aboutyou/data-fetcher';
import {CustomPagesMetaService_GetPageMetaDataLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/custom_pages/v1/meta/service.grpc.lazy';
import {GetPageMetaDataResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/custom_pages/v1/meta/service.types';
import {Head} from '@aboutyou/head-elements';
import {RouterErrorHandler, useRecentFullUrl} from '@aboutyou/router';
import {TrackContentPageView} from '@aboutyou/tracking';
import React from 'react';
import {
  ensure404Page,
  extractMetaAndLinkTags,
  isSeoData,
  isUnavailable,
  setDataTestIds,
} from '../../../shared-deprecated/metaUtils';
import {useEnsureRedirectData} from '../../../shared-deprecated/useEnsureRedirectData';
import {useCustomPageId} from '../useCustomPageId';
import {usePreviewSessionId} from '../usePreviewSessionId';

/**
 * Renders all meta information and handles basic tracking events of the CustomPage. This component is also responsible for redirects and 404 handling.
 */
export const CustomPageMetadata: React.FC = props => {
  return (
    <DataFetcher
      request={useCustomPageMetadata({})}
      Error={RouterErrorHandler}
      View={View}
      viewProps={props}
    />
  );
};

export const useCustomPageMetadata = ({
  pageId,
  customFullUrl,
  disabled,
}: {
  pageId?: number;
  customFullUrl?: string;
  disabled?: boolean;
}) => {
  const ensureRedirectData = useEnsureRedirectData();
  const urlPageId = useCustomPageId();
  const fullUrl = useRecentFullUrl();
  const previewSessionId = usePreviewSessionId();

  return useGrpcRequest(
    CustomPagesMetaService_GetPageMetaDataLazy,
    {
      pageId: pageId ?? urlPageId!,
      url: customFullUrl ?? fullUrl,
      previewSessionId,
    },
    {
      disabled,
      validateData: pageId ? undefined : ensureRedirectData,
      validateError: ensure404Page,
    },
  );
};
export const View: React.FC<GetPageMetaDataResponse> = ({meta}) => {
  if (!isSeoData(meta) || isUnavailable(meta)) {
    return null;
  }

  const seoData = meta.type.seoData;
  const [metaTags, linkTags] = setDataTestIds(
    extractMetaAndLinkTags(seoData.elements),
  );

  return (
    <>
      <TrackContentPageView pageTitle={seoData.title} />
      <Head meta={metaTags} link={linkTags}>
        <title data-testid="MetaTitle">{seoData.title}</title>
      </Head>
    </>
  );
};
